import fetchMatchingManufacturer, {
    Manufacturer,
} from '../../../../../api/fetchMatchingManufacturer';

export const onManufacturerSearch = (text: string): Promise<Manufacturer[]> => {
    return fetchMatchingManufacturer(text).then((res) => {
        return res;
    });
};
